export const Constants = {
  Modules: {
    ANON: 'anon',
    AV: 'av',
    DS: 'ds',
    FMV: 'fmv',
    KDB: 'kdb',
    KIFAM: 'kifam',
    KTV: 'ktv',
    LS: 'ls',
    SCHEDTOOL: 'schedtool',
    TT: 'tt'
  }
}
